export enum CellModelStatus {
    Empty, 
    Half,
    Full
}